











import { Component, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { GetTeamList } from "@/api/pdTeam";
import { SetPatientTeam } from "@/api/pdReferral";

@Component
export default class SetTeam extends AbpBase {
  @Prop() patientId: number; //患者编号
  @Prop() communityId: number; //社区Id
  loading: boolean = false;
  teamId: any; //选中的团队
  data: any[] = [];
  columns = [
    {
      title: "团队名称",
      key: "name"
    }
  ];

  created() {
    this.getData();
  }

  async getData() {
    if (this.communityId) {
      this.loading = true;
      let res = await GetTeamList();
      this.loading = false;
      let teamList = res.data;
      if (teamList && teamList.length != 0) {
        this.data = teamList.filter(x => x.communityId == this.communityId);
      }
    }
  }

  handleTeamChange(row: any) {
    this.teamId = row.id;
  }

  async submit() {
    if (!this.teamId) {
      this.$Message.error("请选择一个团队");
      return false;
    }
    let payload = { patientId: this.patientId, teamId: this.teamId };
    await SetPatientTeam(payload);
    return true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdReferral/pdScreening/setTeam.vue